import styled from 'styled-components';
import { FileOpenIcon } from 'ia-react-core';
import { FC, HTMLProps } from 'react';

export const StyledDownloadIconWrapper = styled.div`
  display: inline;
  white-space:nowrap;
  > svg { width: 15px;
  height: 15px;
  position: absolute;
  margin-left: 3px;
  margin-top: 2px;
 }
`;

export const StyledLinksSection = styled.div`
  padding: 0 16px 16px 16px;
`;

export const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const StyledListItem = styled.li`
  &:before{
    content:"•";
    font-size: 14px;
    padding-right: 8px;
  }
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
`;

export const StyledLink = styled.span`
  width: 90%;
  font-weight: 600;
  white-space: initial;
  > a {
    color: ${({ theme }) => theme.colors.blue5};
  }
`;

export const StyledPrincipalLink = styled.span`
  font-weight: 600;
  white-space: initial;
  margin-top: 17px;
  width: 90%;
  padding-top: 0;
  margin-top: 0;
  > a {
    color: ${({ theme }) => theme.colors.blue5};
  }
`;

export const StyledDocumentIcon = styled<FC<HTMLProps<SVGElement>>>(FileOpenIcon)`
  color: ${({ theme }) => theme.colors.blue5};
`;
